module.exports = __webpack_public_path__ + "33ef2bd6b4a9a4656feb7a4a84c09ef3.png";